export const rules = {
  cutOrder: [{ required: true }],
  order: [{ required: true }],
  cut: [{ required: false }],
  tags: [{ required: true }],
};
